export default __webpack_public_path__ + "static/media/lightning.11411931.svg";